require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-relazioni-e-conferenze-evento-di-esempio-non-toccare.json") })
        }
      }, "path---en-relazioni-e-conferenze-evento-di-esempio-non-toccare");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-relazioni-e-conferenze-evento-di-esempio-non-toccare!./.cache/json/en-relazioni-e-conferenze-evento-di-esempio-non-toccare.json
// module id = 606
// module chunks = 231608221292675